import type { ValueOf } from "@/shared/types/helperTypes";

export const DATE_EXACTNESS_SCOPE = {
    exact: "0",
    oneYear: "1",
    twoYears: "2",
    fiveYears: "5",
    tenYears: "10",
} as const;
export type DateExactnessScope = ValueOf<typeof DATE_EXACTNESS_SCOPE>;

export const DATE_EXACTNESS_OPTIONS = [
    {
        fullLabel: "year.exactness.exact",
        label: "year.exactness.thisYear",
        id: DATE_EXACTNESS_SCOPE.exact,
    },
    {
        fullLabel: "year.exactness.plusMinus1YearShort",
        label: "year.exactness.plusMinus1Year",
        id: DATE_EXACTNESS_SCOPE.oneYear,
    },
    {
        fullLabel: "year.exactness.plusMinus2YearsShort",
        label: "year.exactness.plusMinus2Years",
        id: DATE_EXACTNESS_SCOPE.twoYears,
    },
    {
        fullLabel: "year.exactness.plusMinus5YearsShort",
        label: "year.exactness.plusMinus5Years",
        id: DATE_EXACTNESS_SCOPE.fiveYears,
    },
    {
        fullLabel: "year.exactness.plusMinus10YearsShort",
        label: "year.exactness.plusMinus10Years",
        id: DATE_EXACTNESS_SCOPE.tenYears,
    },
] as const;
